import './style.scss'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { userStateData } from '../../data/userStateData'
import AppFormButton from '../../components/app_formButton/AppFormButton'

function AppEntry() {
	// Use state to check the log in redirect before adding the page to avoid loading images if the page will automatically redirect
	const [logInCheck, setLogInChecked] = useState<boolean>(false)
	
	useEffect(() => {
		// Check if the user is logged in and redirect if they are
		if (userStateData.loggedIn) {
			window.location.replace(PAGE_URLS.APP_EXPLORE)
		} else {
			setLogInChecked(true)
		}
	}, [])
	
	return (
		<>
			{logInCheck === true && 
				// <div className='section-wrap'>
				// 	<div className='section-content'>
						<div className='entry-app-content'>
							<div className='entry-app-content-section'>
								<div className='entry-app-top-section-wrap'>
									<div className='entry-app-logo-wrap'>
										<img
											src={'/imgs/entry/logo.svg'}
											className="entry-app-logo-img"
											alt="Peyto logo"
										/>
									</div>
									<div className='entry-app-form-title'>One app. Every player.<br/>Total connection.</div>
								</div>
								<div className='entry-app-img-wrap'>
									{
										[...Array(7)].map((_, index) => 
											<img
												className='entry-app-img-item'
												src={`/imgs/entry/pic_${index}.png`}
												key={`sportImgs${index}`}
											/>
										)
									}
								</div>
								<div className='entry-app-form'>
									<AppFormButton
										label={'Sign Up'}
										size='medium'
										onClick={() => window.location.replace(PAGE_URLS.APP_SIGN_UP)}
										fullWidth={true}
									/>
									<AppFormButton
										label={'Sign In'}
										style='secondary'
										size='medium'
										onClick={() => window.location.replace(PAGE_URLS.APP_LOGIN)}
										fullWidth={true}
									/>
								</div>
							</div>
						</div>
				// 	</div>
				// </div>
			}
		</>
	)
}

export default AppEntry
